import {Geometry} from '@turf/helpers';
import {Drawing} from './drawing';
import {Ttm} from './ttm';
import {EntityImage} from './entityimage';

export class EntityToSave {
    id: number;
    name?: string;
    drawing_id: number;
    ttm_id?: number;
    handle: number;
    bbox: Geometry;
    pole: Geometry;
    gnd: Geometry;
    gnd_handle?: number;
    gnd_actual?: Geometry;
    line?: any;
    attr: any;
    width?: number;
    height?: number;
    drawing?: Drawing;
    ttm?: Ttm;
    image?: EntityImage;
    gnd_image?: EntityImage;
    belongsToHandle?: number;
    bord?: any;
    type?: string;
    polygon?: any;

    scale_x?: number;
    scale_y?: number;
    rotation?: number;
    color?: string;
}
